import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/**
 * Types and Action Creators
 */
const { Types, Creators } = createActions({
    listPartsRequest: ['category', 'identifier'],
    listPartsSuccess: ['category', 'parts'],
    listPartsFailure: null,
    refreshParts: null,
});

export const PartTypes = Types;
export default Creators;

/**
 * Initial State
 */
export const INITIAL_STATE = Immutable({
    parts: {
        engines: null,
        paintworks: null,
        decors: null,
        packages: null,
        basicvehicle: null,
        lastrada: null,
    },
    fetching: null,
    error: null,
});

/**
 * Request the list of parts
 *
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export const listPartsRequest = (state) => (
    state.merge({
        fetching: true,
    })
);

/**
 * A successful parts lookup and merge the new data with the store.
 *
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export const listPartsSuccess = (state, action) => {
    const { parts } = action;
    return state.merge({
        parts: {
            ...parts.data,
        },
        fetching: false,
    });
};

/**
 * Failed to get the parts
 *
 * @param {Object} state
 * @return {Object}
 */
export const listPartsFailure = state => (
    state.merge({
        fetching: false,
        error: true,
    })
);

/**
 * Failed to get the parts
 *
 * @param {Object} state
 * @return {Object}
 */
export const refreshParts = state => (
    state.merge({
        parts: INITIAL_STATE.parts,
        fetching: null,
        error: null,
    })
);


/**
 *  Hookup Reducers To Types
 */
export const reducer = createReducer(INITIAL_STATE, {
    [Types.LIST_PARTS_REQUEST]: listPartsRequest,
    [Types.LIST_PARTS_SUCCESS]: listPartsSuccess,
    [Types.LIST_PARTS_FAILURE]: listPartsFailure,
    [Types.REFRESH_PARTS]: refreshParts,
});
